<template>
  <div class="section-parent">
    <a @click.prevent="toggleContent" class="section-link" href v-if="section.name">
      <i :class="'fa fa-' + section.icon"></i>
      {{ section.name }}
    </a>
    <div :class="{ expanded: show_content }" class="section-content">
      <div
        class="scroller"
        v-if="section.type == 'list' && page[section.prop_name] && page[section.prop_name].length"
        v-show="!section.editing"
      >
        <table class="items">
          <thead>
            <tr>
              <td
                :key="index"
                v-for="(prop, index) in section.properties.filter(
                  (prop) => prop.display && $store.getters.showOn(page, prop.show_on, prop.hide_on)
                )"
              >
                {{ prop.label }}
              </td>
              <td colspan="2"></td>
            </tr>
          </thead>
          <tbody v-sortable="{ handle: '.move', onUpdate: reorderItems }">
            <tr :key="item._id" v-for="(item, $index) in list">
              <td
                :key="index"
                v-for="(prop, index) in section.properties.filter(
                  (prop) => prop.display && $store.getters.showOn(page, prop.show_on, prop.hide_on)
                )"
              >
                <img
                  :src="item[prop.prop_name]"
                  class="uploaded-img"
                  v-if="prop.type == 'image' && item[prop.prop_name]"
                />
                <span v-else-if="prop.type == 'chk'">{{ item[prop.prop_name] ? "Yes" : "No" }}</span>
                <span v-else-if="prop.type == 'cbo' && needsDisplayText(prop.items)">{{
                  item._display_text || ""
                }}</span>
                <span v-else-if="prop.type == 'date-ms'">{{ formatDate(item[prop.prop_name], "DD/MM/YYYY") }}</span>
                <span v-else-if="prop.type == 'price'"
                  >&pound;{{ item[prop.prop_name].toFixed ? item[prop.prop_name].toFixed(2) : "0.00" }}</span
                >
                <span v-else>{{ item[prop.prop_name] }}</span>
              </td>
              <td class="actions">
                <a
                  v-if="resetable"
                  v-tooltip="'Reset password'"
                  @click.prevent="showResetModal($index)"
                  class="edit"
                  href="#"
                >
                  <i class="fa fa-unlock-alt"></i>
                </a>
                <a v-if="!section.insert_only" @click.prevent="editItem(item, $index)" class="edit" href="#">
                  <i class="fa fa-pencil"></i>
                </a>
                <a class="move" href="#" v-if="!section.order_by">
                  <i class="fa fa-sort"></i>
                </a>
                <a @click.prevent="showDeleteModal($index)" class="delete" href="#">
                  <i class="fa fa-close"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="section.type == 'sub'">
        <ul class="list scroller" v-sortable="{ handle: '.handle', onUpdate: reorderPages }">
          <li :key="sub.ItemID" v-for="sub in section.subs">
            <router-link :to="pageLink(sub)">
              <i class="fa fa-file-o"></i>
              {{ sub.name }}
              <span class="tooltip" data-balloon="This item is hidden" data-balloon-pos="right" v-show="sub.hide">
                <i class="fa fa-eye-slash hidden"></i>
              </span>
            </router-link>

            <span class="actions">
              <a @click.prevent="duplicate(sub)" href="#" v-if="section.duplicable">
                <i class="fa fa-copy"></i>
              </a>
              <a :class="{ handle: !updating }" class="move" href="#" v-if="!section.order_by">
                <i class="fa fa-sort"></i>
              </a>
              <a @click.prevent="updating ? false : confirmDeletePage(sub)" class="delete" href="#">
                <i class="fa fa-trash"></i>
              </a>
            </span>
          </li>
        </ul>
      </div>

      <button @click="addItem" class="btn edit-add space-top" v-if="showAddButton" v-show="!section.editing">
        <i class="fa fa-plus"></i> Add
      </button>

      <div
        :class="{ block: section.type == 'list scroller' }"
        v-if="!section.type || section.type == 'standard' || section.editing"
      >
        <section-property
          :adding="section.current_i == -1"
          :internal="internal"
          :key="prop._id"
          :page="page"
          :parent="section.editing ? section.page : page"
          :prop="prop"
          :sectiontype="section.type"
          v-for="prop in visibleProperties"
        />
        <div class="row controls" v-show="section.editing">
          <button @click="saveEdit" class="btn edit-save"><i class="fa fa-check-square-o"></i> Save</button>
          <button @click="cancelEdit" class="btn edit-cancel"><i class="fa fa-undo"></i> Cancel</button>
        </div>
      </div>
    </div>

    <modal-yes-no
      :message="'Are you sure you want to delete this?'"
      :show="showDeleteItemModal"
      @close="showDeleteItemModal = false"
      @yes="deleteItem"
    ></modal-yes-no>
    <modal-yes-no
      :message="'Are you sure you want to delete this?'"
      :show="showDeletePageModal"
      @close="showDeletePageModal = false"
      @yes="deletePage"
    ></modal-yes-no>
    <modal-yes-no
      :message="'Are you sure you want to reset this user\'s password?'"
      :show="showResetItemModal"
      @close="showResetItemModal = false"
      @yes="resetItem"
    ></modal-yes-no>
  </div>
</template>

<script>
import api from "@/services/api"

import SectionProperty from "./SectionProperty"
import ModalYesNo from "@/components/ModalYesNo.vue"
import shortid from "shortid"
import datetimeutil from "date-and-time"

export default {
  name: "SchemaSection",
  props: ["page", "section", "single", "internal", "resetable"],
  data: function () {
    return {
      showDeleteItemModal: false,
      showResetItemModal: false,
      delete_i: -1,
      reset_i: -1,
      show_content: false,
      updating: false,
      showDeletePageModal: false,
      pageInQuestion: {}
    }
  },
  components: { SectionProperty, ModalYesNo },
  created() {
    this.show_content = this.single
    if (!this.show_content) if (!this.section.name) this.show_content = true

    // Get display text for list items
    if (this.section.type == "list") {
      this.section.properties
        .filter((prop) => prop.display && this.$store.getters.showOn(this.page, prop.show_on, prop.hide_on))
        .forEach((prop) => {
          if (prop.type == "cbo" && this.page[this.section.prop_name]) {
            this.page[this.section.prop_name].forEach((item) => {
              this.getDisplayText(item, prop)
            })
          }
        })
    }

    if (this.section.type == "sub") {
      if (!this.section.subs) this.$set(this.section, "subs", [])

      this.getSubPages()
    }
  },
  computed: {
    visibleProperties: function () {
      if (this.section.type == "list") {
        var filtered = this.section.properties.filter((prop) =>
          this.$store.getters.showOn(this.page, prop.show_on, prop.hide_on)
        )

        var conditionfiltered = []
        filtered.forEach((prop) => {
          if (!prop.condition) conditionfiltered.push(prop)
          else if (this.section.page[prop.condition.prop] == prop.condition.value) conditionfiltered.push(prop)
        })

        return conditionfiltered
      }

      if (this.page.disable_navigation)
        return this.section.properties.filter((prop) => ["name", "hide", "disable_navigation"].includes(prop.prop_name))

      return this.section.properties.filter((prop) => this.$store.getters.showOn(this.page, prop.show_on, prop.hide_on))
    },
    list: function () {
      if (this.section.type == "list" && this.section.order_by)
        return JSON.parse(
          JSON.stringify(
            this.page[this.section.prop_name].sort((a, b) => a[this.section.order_by] - b[this.section.order_by])
          )
        )
      return this.page[this.section.prop_name]
    },
    showAddButton: function () {
      // If max items reached
      if (this.section.max)
        if (this.page[this.section.prop_name])
          if (this.page[this.section.prop_name].length >= this.section.max) return false

      // If not list and not sub page
      if (this.section.type != "list" && this.section.type != "sub") return false

      return true
    }
  },
  methods: {
    formatDate(d) {
      return datetimeutil.format(new Date(d * 1000), "DD/MM/YYYY")
    },
    duplicate(page) {
      api.getPage(page.ItemID, this.internal, this.section.shadowed_by).then((fullpage) => {
        var orderindex = 1

        if (this.section.order_by && this.section.order_by.type == "date")
          orderindex = datetimeutil.format(new Date(), "YYYY-MM-DD")
        else if (this.section.order_by && this.section.order_by.type == "date-ms")
          orderindex = Math.floor(new Date().getTime() / 1000).toString()
        else if (this.section.subs.length) orderindex = this.section.subs.length + 1

        if (fullpage.url) fullpage.url = fullpage.url + "-copy"
        fullpage.OrderIndex = orderindex
        api.duplicatePage(fullpage, this.internal).then((response) => {
          this.$store.dispatch({
            type: "setSuccess",
            message: "Copy successful"
          })
          this.$router.push({
            name: "page-edit",
            params: { id: response.data }
          })
        })
      })
    },
    getSubPages() {
      if (this.section.order_by && (this.section.order_by.type == "date" || this.section.order_by.type == "date-ms"))
        api.getSubPagesDesc(this.section.item_type, this.page.ItemID).then((subs) => {
          this.section.subs = subs
          this.$nextTick().then(() => (this.updating = false))
        })
      else
        api.getSubPages(this.section.item_type, this.page.ItemID).then((subs) => {
          this.section.subs = subs
          this.$nextTick().then(() => (this.updating = false))
        })
    },
    confirmDeletePage(page) {
      this.pageInQuestion = page
      this.showDeletePageModal = true
    },
    deletePage() {
      if (!this.updating) {
        this.updating = true
        var index = this.section.subs
          .map((page) => {
            return page.ItemID
          })
          .indexOf(this.pageInQuestion.ItemID)
        this.section.subs.splice(index, 1)
        var promises = []
        if (!this.section.order_by) promises.push(this.updateOrderIndexes())

        this.pageInQuestion.url = ""
        this.pageInQuestion.active = false
        this.pageInQuestion.ItemType = "_" + this.pageInQuestion.ItemType

        promises.push(api.deletePage(this.pageInQuestion))

        Promise.all(promises).then(() => this.getSubPages())
      }
    },
    reorderPages: function (event) {
      this.updating = true
      this.section.subs.splice(event.newIndex, 0, this.section.subs.splice(event.oldIndex, 1)[0])
      this.updateOrderIndexes().then(() => this.getSubPages())
    },
    updateOrderIndexes: function () {
      return new Promise((resolve, reject) => {
        var promises = []
        this.section.subs.forEach((page, i) => {
          page.OrderIndex = i + 1
          promises.push(api.updatePage(page))
        })
        Promise.all(promises).then(() => resolve())
      })
    },
    pageLink: function (page) {
      return {
        name: "page-edit",
        params: { id: page.ItemID, type: page.ItemType.split(".")[1] }
      }
    },
    toggleContent: function () {
      if (!this.single) this.show_content = !this.show_content
    },
    showContent: function () {
      this.show_content = true
    },
    editItem: function (item, i) {
      this.$emit("editing", { editing: false })
      this.$nextTick().then(() => {
        this.$emit("editing", { editing: true, page: item, i })
      })
    },
    addItem: function () {
      this.$emit("editing", { editing: false })
      this.$nextTick().then(() => {
        if (this.section.type == "list")
          this.$emit("editing", { editing: true, page: { _id: shortid.generate() }, i: -1 })
        if (this.section.type == "sub") this.$emit("add")
      })
    },
    showDeleteModal: function (i) {
      this.delete_i = i
      this.showDeleteItemModal = true
    },
    showResetModal: function (i) {
      this.reset_i = i
      this.showResetItemModal = true
    },
    deleteItem: function () {
      this.$emit("delete", { i: this.delete_i })
      this.delete_i = -1
      this.showDeleteItemModal = false
    },
    resetItem: function () {
      this.$emit("reset", { i: this.reset_i })
      this.reset_i = -1
      this.showResetItemModal = false
    },
    cancelEdit: function () {
      this.$emit("editing", { editing: false })
    },
    saveEdit: function () {
      Promise.all(this.$store.state.promises).finally(() => {
        // If property is blank, remove from object
        // To satisfy dynamoDB
        // Might not need to in v2 when using aws-sdk
        for (var property in this.section.page) {
          if (this.section.page.hasOwnProperty(property))
            if (this.section.page[property] === "") delete this.section.page[property]
        }

        this.$emit("save", { newvalue: this.section.page })
      })
    },
    reorderItems: function (event) {
      this.$emit("reorder", {
        newIndex: event.newIndex,
        oldIndex: event.oldIndex
      })
    },
    needsDisplayText: function (items) {
      if (!items) return false
      if (!Array.isArray(items) && !items.prop_name) return true

      return false
    },
    getDisplayText: function (item, prop) {
      return new Promise((resolve, reject) => {
        if (this.needsDisplayText(prop.items)) {
          api.getPage(item[prop.prop_name]).then((res) => {
            this.$set(item, "_display_text", res[prop.list_text])
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.expanded {
  height: auto;
  padding: 2rem;
}
</style>
